import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import logo from "../assets/logo.png";
import {
  ShieldCheckIcon,
  RocketIcon,
  SparklesIcon,
  ZapIcon,
  TagIcon,
  FileTextIcon,
  HelpCircleIcon,
  LockIcon,
  XIcon,
  MenuIcon,
  ChevronRightIcon,
  ArrowRightIcon,
  HeadphonesIcon
} from "./Icons";

function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const close = () => setMobileOpen(false);

  const handleScrollTo = (id) => (e) => {
    close();
    if (location.pathname === "/" || location.pathname === "/vendor") {
      const el = document.getElementById(id);
      if (el) {
        e.preventDefault();
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <header className={`public-header-wrapper ${scrolled ? "scrolled" : ""}`}>
      {/* Top Announcement / Trust Bar */}
      <div className="announcement-bar">
        <div className="announcement-inner">
          <div className="announcement-left">
            <span className="announcement-badge-icon">
              <RocketIcon size={14} color="#a85050" />
            </span>
            <span>Start your online footwear business today. No monthly fees. 0% commission plans.</span>
          </div>
          <div className="announcement-right">
            <ShieldCheckIcon size={14} color="#a85050" />
            <span>Trusted by 10,000+ Indian Sellers</span>
          </div>
        </div>
      </div>

      {/* Main Navigation Bar */}
      <nav className="public-navbar">
        <div className="public-navbar-inner">
          {/* Logo */}
          <Link to="/vendor" className="navbar-brand-link">
            <img src={logo} alt="IM Online" className="navbar-brand-logo" />
            <div className="navbar-brand-text">
              <span className="brand-title">IM ONLINE</span>
              <span className="brand-subtitle">SELLER CENTER</span>
            </div>
          </Link>

          {/* Desktop Navigation Links */}
          <ul className="public-nav-links public-nav-links-desktop">
            <li>
              <a href="/vendor#our-agenda" onClick={handleScrollTo("our-agenda")}>
                Our Mission &amp; Agenda
              </a>
            </li>
            <li>
              <a href="/vendor#how-it-works" onClick={handleScrollTo("how-it-works")}>
                How It Works
              </a>
            </li>
            <li>
              <a href="/vendor#pricing" onClick={handleScrollTo("pricing")}>
                Pricing
              </a>
            </li>
            <li>
              <NavLink to="/vendor/requirements" activeClassName="active-nav">
                Requirements
              </NavLink>
            </li>
            <li>
              <a href="/vendor#faq" onClick={handleScrollTo("faq")}>
                FAQ
              </a>
            </li>
            <li>
              <NavLink to="/vendor/login" className="nav-login-link">
                Login
              </NavLink>
            </li>
            <li>
              <Link to="/vendor/register" className="btn-nav-cta">
                <span>Start Selling Free</span>
                <span className="arrow-span">&rarr;</span>
              </Link>
            </li>
          </ul>

          {/* Mobile Quick Action Buttons & Hamburger */}
          <div className="mobile-nav-actions">
            <Link to="/vendor/login" className="mobile-header-login-btn">
              Login
            </Link>
            <Link to="/vendor/register" className="mobile-header-sell-btn">
              Sell Free
            </Link>
            <button
              className="nav-hamburger"
              onClick={() => setMobileOpen(true)}
              aria-label="Open navigation menu"
            >
              <MenuIcon size={20} color="#0f172a" />
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Drawer Navigation (Premium Overhaul) */}
      <div
        className={`mobile-menu-overlay ${mobileOpen ? "open" : ""}`}
        onClick={close}
        aria-hidden="true"
      />
      <aside
        className={`mobile-menu-panel ${mobileOpen ? "open" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-label="Mobile Navigation Drawer"
      >
        {/* 1. Header with Brand Logo, Verified Pill & Smooth Close Button */}
        <div className="drawer-header">
          <Link to="/vendor" className="drawer-brand" onClick={close}>
            <img src={logo} alt="IM Online" className="drawer-logo" />
            <div className="drawer-brand-text">
              <span className="drawer-brand-title">IM ONLINE</span>
              <span className="drawer-brand-sub">SELLER CENTER</span>
            </div>
          </Link>
          <button onClick={close} className="drawer-close-btn" aria-label="Close menu">
            <XIcon size={18} color="#0f172a" />
          </button>
        </div>

        {/* 2. Verified Status Strip */}
        <div className="drawer-status-strip">
          <div className="drawer-status-badge">
            <span className="drawer-status-pulse" />
            <span>0% Commission Footwear Portal India</span>
          </div>
        </div>

        {/* 3. Navigation Menu Items Group */}
        <div className="drawer-nav-section">
          <span className="drawer-section-label">PORTAL NAVIGATION</span>
          <div className="drawer-menu-list">
            <a
              href="/vendor#our-agenda"
              className="drawer-nav-item"
              onClick={handleScrollTo("our-agenda")}
            >
              <div className="drawer-nav-icon-tile">
                <SparklesIcon size={18} color="#a85050" />
              </div>
              <div className="drawer-nav-text-col">
                <span className="drawer-nav-title">Our Mission &amp; Agenda</span>
                <span className="drawer-nav-desc">0% Commission &amp; Merchant Pledge</span>
              </div>
              <span className="drawer-nav-badge">Pledge</span>
              <ChevronRightIcon size={15} color="#94a3b8" />
            </a>

            <a
              href="/vendor#how-it-works"
              className="drawer-nav-item"
              onClick={handleScrollTo("how-it-works")}
            >
              <div className="drawer-nav-icon-tile">
                <ZapIcon size={18} color="#a85050" />
              </div>
              <div className="drawer-nav-text-col">
                <span className="drawer-nav-title">How It Works</span>
                <span className="drawer-nav-desc">From listing to doorstep dispatch</span>
              </div>
              <span className="drawer-nav-badge">4 Steps</span>
              <ChevronRightIcon size={15} color="#94a3b8" />
            </a>

            <a
              href="/vendor#pricing"
              className="drawer-nav-item"
              onClick={handleScrollTo("pricing")}
            >
              <div className="drawer-nav-icon-tile">
                <TagIcon size={18} color="#a85050" />
              </div>
              <div className="drawer-nav-text-col">
                <span className="drawer-nav-title">Pricing &amp; Plans</span>
                <span className="drawer-nav-desc">Basic, Growth &amp; Pro 0% Plans</span>
              </div>
              <span className="drawer-nav-badge highlight">0% Cut</span>
              <ChevronRightIcon size={15} color="#94a3b8" />
            </a>

            <NavLink
              to="/vendor/requirements"
              className="drawer-nav-item"
              onClick={close}
            >
              <div className="drawer-nav-icon-tile">
                <FileTextIcon size={18} color="#a85050" />
              </div>
              <div className="drawer-nav-text-col">
                <span className="drawer-nav-title">Seller Requirements</span>
                <span className="drawer-nav-desc">Aadhaar, PAN &amp; Bank Account</span>
              </div>
              <span className="drawer-nav-badge">2-Min KYC</span>
              <ChevronRightIcon size={15} color="#94a3b8" />
            </NavLink>

            <a
              href="/vendor#faq"
              className="drawer-nav-item"
              onClick={handleScrollTo("faq")}
            >
              <div className="drawer-nav-icon-tile">
                <HelpCircleIcon size={18} color="#a85050" />
              </div>
              <div className="drawer-nav-text-col">
                <span className="drawer-nav-title">Seller FAQ</span>
                <span className="drawer-nav-desc">Got questions? We have answers</span>
              </div>
              <ChevronRightIcon size={15} color="#94a3b8" />
            </a>
          </div>
        </div>

        {/* 4. Seller Account Sign In Card */}
        <div className="drawer-account-card">
          <div className="drawer-account-top">
            <div className="drawer-lock-icon-wrap">
              <LockIcon size={18} color="#a85050" />
            </div>
            <div>
              <span className="drawer-account-title">Already a Registered Seller?</span>
              <span className="drawer-account-sub">Access your orders &amp; product inventory</span>
            </div>
          </div>
          <NavLink
            to="/vendor/login"
            className="drawer-account-login-btn"
            onClick={close}
          >
            <span>Seller Login</span>
            <ArrowRightIcon size={14} />
          </NavLink>
        </div>

        {/* 5. Footer with Start Selling CTA & Trust Banner */}
        <div className="drawer-footer">
          <Link
            to="/vendor/register"
            className="drawer-cta-primary"
            onClick={close}
          >
            <span>Start Selling Free</span>
            <ArrowRightIcon size={18} />
          </Link>

          <div className="drawer-trust-banner">
            <ShieldCheckIcon size={15} color="#16a34a" />
            <span>Trusted by 10,000+ Footwear Merchants across India</span>
          </div>

          <a
            href="mailto:support@imonline.shop"
            className="drawer-help-row"
          >
            <HeadphonesIcon size={14} color="#64748b" />
            <span>Seller Help Desk: support@imonline.shop</span>
          </a>
        </div>
      </aside>
    </header>
  );
}

export default Navbar;
